import $ from "jquery";

const scrollTop = () => {
    const target = ".wapp-btn-arrow__up";
    const $target = $(target);

    const init = () => {
        $(document).ready(function () {
        if ($target.length) {
            exec();
        }
        });
    };

    const exec = () => {
        $(window).on('scroll', function(){
            if ($(this).scrollTop() > 180) {
                $target.addClass('showed');
            } else {
                $target.removeClass('showed');

            }
        });
    };

    init();
};

try {
    scrollTop();
} catch (error) {
    throw Error(error);
}
